const prefix = 'fasr';
const iconName = 'code-branch';
const width = 448;
const height = 512;
const aliases = [];
const unicode = 'f126';
const svgPathData = 'M48 48v64h64V48H48zM0 0H48h64 48V48v64 48H112h-8v96c20.1-15.1 45-24 72-24h96c39.8 0 72-32.2 72-72h-8H288V112 48 0h48 64 48V48v64 48H400h-8c0 66.3-53.7 120-120 120H176c-39.8 0-72 32.2-72 72h8 48v48 64 48H112 48 0V464 400 352H48h8V160H48 0V112 48 0zM112 400H48v64h64V400zM400 48H336v64h64V48z';

export default {
  prefix,
  iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ] };
